module.exports = __webpack_public_path__ + "static/media/gry-ortograficzne-dla-dzieci.c95010f4.png";